export default __webpack_public_path__ + "static/media/Invoice_Line.fc2a1e4c.svg";